"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactCustomScrollbars = require("react-custom-scrollbars");

var _overrides = require("../../../utils/overrides");

function ScrollBar(_ref) {
  var children = _ref.children,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      width = _ref.width,
      height = _ref.height,
      autoHide = _ref.autoHide,
      autoHeight = _ref.autoHeight,
      autoHeightMin = _ref.autoHeightMin,
      autoHeightMax = _ref.autoHeightMax,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "overrides", "className", "width", "height", "autoHide", "autoHeight", "autoHeightMin", "autoHeightMax"]);
  // Overrides
  var override = (0, _overrides.getOverrides)(overridesProp, ScrollBar.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classNameProp);
  var style = {};
  if (width) style.width = width;
  if (height) style.height = height;
  var rootProps = (0, _extends2.default)({
    style: style,
    autoHide: autoHide,
    autoHeight: autoHeight,
    autoHeightMin: autoHeightMin,
    autoHeightMax: autoHeightMax
  }, override.root);
  return /*#__PURE__*/_react.default.createElement(_reactCustomScrollbars.Scrollbars, (0, _extends2.default)({
    className: rootClassName
  }, rootProps), children);
}

ScrollBar.overrides = ['root'];
ScrollBar.defaultProps = {
  overrides: {},
  autoHide: true
};
process.env.NODE_ENV !== "production" ? ScrollBar.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  autoHide: _propTypes.default.bool,
  autoHeight: _propTypes.default.bool,
  autoHeightMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  autoHeightMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(ScrollBar);

exports.default = _default;